import React from "react";
import { ValueEditor, ValueEditorProps } from "react-querybuilder";
import { CustomComponentType } from "../constants";
import { CustomFieldDependantSelector } from "./custom-field-dependant-selector";
import { CustomFieldSelector } from "./custom-field-selector";

export const CustomValueEditor: React.FC<ValueEditorProps> = (props: ValueEditorProps) => {
    const { fieldData } = props;

    if (fieldData?.customComponentType === CustomComponentType.DependantSelector) {
        return <CustomFieldDependantSelector {...props} options={fieldData.values} />;
    } else if (fieldData?.customComponentType === CustomComponentType.Selector) {
        return <CustomFieldSelector {...props} options={fieldData.values} />;
    }

    return <ValueEditor {...props} />;
};
